import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-20 bg-white" data-id="element-110">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg mx-auto text-[#5c4a32]" data-id="element-112">
          <p className="text-2xl font-serif font-bold text-[#1a3c2a] text-center mb-8" data-id="element-113">
            Every parent knows that 2 AM moment.
          </p>

          <div className="space-y-6 text-lg leading-relaxed" data-id="element-114">
            <p data-id="element-115">Kid with fever. Spouse with headache. Your stomach in knots.</p>
            <p data-id="element-116">
              Your medicine cabinet has aspirin that stopped working. Google
              gives dangerous advice. The doctor's office opens at 9 AM.
            </p>
            <p className="font-medium text-[#1a3c2a] italic text-xl border-l-4 border-[#c9a84c] pl-6 py-2 bg-[#faf8f0]" data-id="element-117">
              What if you had kitchen remedies that work faster than waiting?
            </p>
            <p data-id="element-118">You do. 200+ recipes your grandparents knew.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}